export const OptionStrategies = {
  Strangle: 'Strangle',
  Straddle: 'Straddle',
  VerticalSpread: 'Vertical Spread',
  CalendarSpread: 'Calendar Spread',
  Butterfly: 'Butterfly',
} as const;
export type OptionStrategies = (typeof OptionStrategies)[keyof typeof OptionStrategies];
